export default "__VITE_ASSET__BnlSIm1P__"